<template>
  <div>
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-row class="mb-1">
              <b-col
                cols="6"
                class="d-flex justify-content-start align-items-center"
              >
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class="fas fa-table mr-2" /> Danh Sách Bản Ghi
                </h5>
                <b-badge
                  variant="info"
                  class="ml-3 font-weight-bold"
                >
                  Tổng cộng: {{ totalChange }} thay đổi
                </b-badge>
              </b-col>
              <b-col
                cols="6"
                class="text-right"
              >
                <b-button
                  v-if="updatable"
                  v-ripple
                  variant="danger"
                  class="mr-1"
                  @click="onReject"
                >
                  Từ chối
                </b-button>
                <b-button
                  v-if="updatable"
                  v-ripple
                  variant="success"
                  @click="onApprove"
                >
                  Phê duyệt
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <vue-good-table
                  class="my-table"
                  line-numbers
                  :columns="columns"
                  :rows="dataTable"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <!-- Column: Common -->
                    <span>{{ props.formattedRow[props.column.field] }}</span>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
    <b-modal
      id="reject-reason-modal"
      ref="reject-reason-modal"
      title="Xác nhận từ chối yêu cầu thay đổi thông tin sinh viên"
      centered
      :hide-footer="true"
      :no-close-on-backdrop="true"
    >
      <RejectReasonModal
        :student-id="studentId"
        @cancel="onCancel"
        @rejected="onRejected"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BCol, BContainer, BOverlay, BRow, BBadge, BButton, BModal,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import RejectReasonModal from '@/views/curriculum-vitae/ReasonRejectStudentChangeRequest.vue'
import api from './api'

export default {
  name: 'ApproveStudentChangeRequest',
  directives: {
    Ripple,
  },
  components: {
    RejectReasonModal,
    BCard,
    BCol,
    BContainer,
    BOverlay,
    BRow,
    BButton,
    BBadge,
    BModal,
    VueGoodTable,
  },
  props: {
    studentId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      filter: {
        studentId: this.studentId,
      },
      currentMainData: undefined,
      dataTable: [],
      totalChange: 0,
    }
  },
  computed: {
    columns() {
      return [
        {
          label: 'Trường thay đổi',
          field: 'fieldLabel',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Giá trị cũ',
          field: 'oldValue',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Giá trị mới',
          field: 'newValue',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ]
    },
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.STUDENT_CHANGE_REQUEST)
    },
  },
  async created() {
    this.isLoading = true
    try {
      const res = await api.getStudentChangeRequest(this.filter)
      if (res) {
        this.dataTable = res.fieldChanges.changes
        this.totalChange = res.fieldChanges.changeCount
      }
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `[${e.code}] ${e.message}`,
          icon: 'XCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    onReject() {
      if (this.totalChange === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Không có thay đổi nào để từ chối',
            icon: 'InfoIcon',
            variant: 'info',
          },
        })
        return
      }
      this.$refs['reject-reason-modal'].show()
    },
    onCancel() {
      this.$refs['reject-reason-modal'].hide()
    },
    async onRejected() {
      this.$refs['reject-reason-modal'].hide()
      const res = await api.getStudentChangeRequest(this.filter)
      if (res) {
        this.dataTable = res.fieldChanges.changes
        this.totalChange = res.fieldChanges.changeCount
      } else {
        this.dataTable = []
        this.totalChange = 0
      }
    },
    onApprove() {
      if (this.totalChange === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Không có thay đổi nào để phê duyệt',
            icon: 'InfoIcon',
            variant: 'info',
          },
        })
        return
      }
      this.$swal({
        title: 'Bạn chắc chắn muốn duyệt thông tin thay đổi?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await api.approveStudentChangeRequest(this.studentId)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'CheckIcon',
                    variant: 'success',
                  },
                })
                this.$emit('approved')
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              }
            }
          } catch (e) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `[${e.code}] ${e.message}`,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          } finally {
            this.isLoading = false
          }
        }
      })
    },
  },
}
</script>
